module.exports = __webpack_public_path__ + "static/media/recipe-box.d5f77f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recipe-box.png
// module id = 69
// module chunks = 0